enum TabsKind {
	PROGRAMMES = 'programmes',
	SEARCHING_FOR = 'searching_for',
}

export default TabsKind;